import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import CarDetails from '../../Components/CarDetail/CarDetail'
import GreatDeal from '../../Components/GreatDeal/GreatDeal'
import Input from '../../Components/Input/Input'
import PriceBlock from '../../Components/PriceBlock/PriceBlock'
import PriceDetails from '../../Components/PriceDetails/PriceDetails'
import RentalLocation from '../../Components/RentalLocation/RentalLocation'
import BackIcon from '../../assets/images/back-arrow.svg'
import { BookingService } from '../../services/booking.service'
import { StoreInterface } from '../../store/store'
import style from './Checkout.module.scss'
import { checkoutSchema, checkoutType } from './checkout.schema'

const bookingService = new BookingService()
const Checkout = () => {
  const [searchParams] = useSearchParams()
  let navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const { profile } = useSelector((store: StoreInterface) => {
    return store.profile
  })

  const defaultValues = {
    locations: searchParams.getAll('locations').map(e => {
      return { value: e }
    }),
    pickupDate: searchParams.get('pickupDate'),
    pickupTime: searchParams.get('pickupTime'),
    fleetId: searchParams.get('fleetId'),
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    userId: '',
    totalCost: {
      amount: +(searchParams.get('totalCostAmount') || 0),
      currencyCode: searchParams.get('totalCostCurrencyCode') || 0,
    },
  }

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(checkoutSchema),
    defaultValues: defaultValues as any,
  })

  const createBooking = async (data: checkoutType) => {
    // Transform data to match CreateBookingRequest with tripSegments
    const locations = data.locations.map(e => e.value)

    const finalData = {
      vehicleId: data.fleetId,
      tripSegments: [
        {
          pickupAddress: locations[0] || '',
          dropoffAddress: locations[1] || '',
          scheduledAt: new Date(`${data.pickupDate}T${data.pickupTime}`).toISOString(),
          scheduledTz: Intl.DateTimeFormat().resolvedOptions().timeZone,
          flightName: data.flightName || undefined,
        },
      ],
    }

    try {
      setIsLoading(true)
      const token = localStorage.getItem('@authToken')
      if (token) {
        const res = await bookingService.createBooking(finalData, token)
        // Note: The new API doesn't return a payment URL directly
        // You may need to handle payment creation separately
        // For now, redirect to booking confirmation
        navigate(`/booking-confirmation/${res.data.id}`)
      }
      setIsLoading(false)
    } catch (error) {
      console.log(error)
      toast.error('Failed to create booking. Please try again.')
      setIsLoading(false)
    }
  }

  // Payment window functionality removed since we're not using Stripe checkout anymore

  useEffect(() => {
    if (profile) {
      setValue('userId', profile.id)
    } else {
      navigate(-1)
    }
  }, [profile, setValue, navigate])

  return (
    <div className={style.detail}>
      <div className="container">
        <div className={style.detail__back}>
          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img src={BackIcon} alt="Back" />
            See all cars
          </button>
        </div>
        <form className="flex-wrap justify-between" onSubmit={handleSubmit(createBooking)}>
          <div className={style.detail__left}>
            <CarDetails fleetId={defaultValues.fleetId} />

            <Input
              type="text"
              name="flightName"
              label="Flight Name"
              register={register}
              errorMessage={errors.flightName?.message}
            />
            <RentalLocation
              pickupDate={defaultValues.pickupDate || ''}
              pickupTime={defaultValues.pickupTime || ''}
              locations={defaultValues.locations.map(e => e.value) || []}
            />
            {/* <RentalPolicies /> */}
          </div>
          <div className={style.detail__right}>
            <PriceBlock cost={defaultValues.totalCost} />
            <PriceDetails cost={defaultValues.totalCost} isLoading={isLoading} />
            <GreatDeal />
          </div>
        </form>
      </div>
    </div>
  )
}
export default Checkout
